import { defineStore } from 'pinia'

export const usePharmacyStore = defineStore('pharmacy', {
    state: () => ({
        store_reset:0,
    }),
    actions: {
    },
    persist: true,
})
